import React from 'react';
import { AwarenessTemplate } from '../components/training/templates/AwarenessTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getAwarenessContent } from '../data/standards/trainingContent';
import { UpcomingTrainingsSection } from '../components/UpcomingTrainingsSection';

export const ISO9001Awareness = () => {
  const standard = getStandardBySlug('iso-9001');
  const content = getAwarenessContent('iso-9001');

  return (
    <>
      <AwarenessTemplate standard={standard} content={content} />
      <UpcomingTrainingsSection
        pageSlug="iso-9001-awareness"
        title="Upcoming ISO 9001 Awareness Training Sessions"
      />
    </>
  );
};
